export const NAVBAR_ACTIVE = "NAVBAR_ACTIVE"
export const NAVBAR_INACTIVE = "NAVBAR_INACTIVE"
export const PPF_FEATURES = "PPF_FEATURES"
